module.exports = __webpack_public_path__ + "static/media/ecobee-thermostat.f77d885c.jpg";